import React from "react";
import { Card, Row, Col, Table } from "react-bootstrap";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const TemperatureGuide = () => {
  const chartData = {
    labels: ["65°F", "70°F", "75°F", "80°F", "85°F"],
    datasets: [
      {
        label: "Fermentation Time (hours)",
        data: [6, 5, 4, 3, 2.5],
        borderColor: "rgb(75, 192, 192)",
        tension: 0.1,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
        text: "Temperature vs. Fermentation Time",
      },
    },
    scales: {
      y: {
        title: {
          display: true,
          text: "Fermentation Time (hours)",
        },
      },
      x: {
        title: {
          display: true,
          text: "Temperature",
        },
      },
    },
  };

  return (
    <Card className="mb-4">
      <Card.Header>
        <h4>Temperature Guide</h4>
      </Card.Header>
      <Card.Body>
        <Row>
          <Col md={6}>
            <div className="chart-container">
              <Line data={chartData} options={chartOptions} />
            </div>
          </Col>
          <Col md={6}>
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>Temperature</th>
                  <th>Effect on Fermentation</th>
                  <th>Recommended Time</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>65°F (18°C)</td>
                  <td>Slow fermentation, more sour flavor</td>
                  <td>5-6 hours</td>
                </tr>
                <tr>
                  <td>70°F (21°C)</td>
                  <td>Moderate fermentation, balanced flavor</td>
                  <td>4-5 hours</td>
                </tr>
                <tr>
                  <td>75°F (24°C)</td>
                  <td>Active fermentation, mild flavor</td>
                  <td>3-4 hours</td>
                </tr>
                <tr>
                  <td>80°F (27°C)</td>
                  <td>Fast fermentation, less sour</td>
                  <td>2.5-3 hours</td>
                </tr>
                <tr>
                  <td>85°F (29°C)</td>
                  <td>Very fast, risk of over-fermentation</td>
                  <td>2-2.5 hours</td>
                </tr>
              </tbody>
            </Table>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default TemperatureGuide;
